
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import moment from 'moment';
@Component({
  filters: {
    yyyy_mm_dd(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
})
export default class PopDetail extends Vue {
  @Prop() visible!: boolean;
  radio = 4; //直接维护

  confirmEdit() {
    this.$emit('ok', this.radio);
  }
  cancel() {
    this.$emit('cancel');
  }

  mounted() {}
}
